export default __webpack_public_path__ + "static/media/pleaseChooseCorrespondence.8851151b.svg";